import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class IconService {
    constructor(
        private _iconRegistry: MatIconRegistry,
        private _domSanitizer: DomSanitizer,
    ) {
        const iconPack = require(`!svg-inline-loader!../../assets/icons/icon_pack.svg`);

        this._iconRegistry.addSvgIconSetLiteralInNamespace(
            'uipath',
            this._domSanitizer.bypassSecurityTrustHtml(iconPack),
        );
    }
}
